import {Component} from '@angular/core';

@Component({
    selector: 'spinner',
    //I'm using in modal-backdrop classes from bootstrap
    template:
    `<div class="in modal-backdrop spinner-overlay"></div>
     <div class="spinner-message-container" aria-live="assertive" aria-atomic="true">
        <div class="spinner-message">{{ state.message }}</div>
    </div>`
})
export class SpinnerComponent {
    public state:any = {
        message: 'Loading...'
    };
}


// WEBPACK FOOTER //
// ./src/app/_services/spinner.component.ts